import { useState } from 'react';
import { useTheme } from '../../../hooks/useTheme';
import { dentalFaq } from '../../../mocks/dental';

export default function DentalFAQ() {
  const { theme } = useTheme();
  const isLight = theme === 'light';
  const accentText = isLight ? '#0f766e' : '#14b8a6';
  const [open, setOpen] = useState<number | null>(0);

  const ink = isLight ? '#0a1628' : '#ffffff';
  const sub = isLight ? 'rgba(10,22,40,0.72)' : 'rgba(255,255,255,0.58)';
  const border = isLight ? 'rgba(10,22,40,0.09)' : 'rgba(255,255,255,0.07)';

  return (
    <section
      id="faq-odontologia"
      className="py-14 md:py-20 px-4 sm:px-6 scroll-mt-24"
      style={{
        background: isLight ? '#f6fafd' : '#071b2e',
        borderTop: `1px solid ${border}`,
      }}
    >
      <div className="max-w-3xl mx-auto">
        <h2
          className="font-heading text-2xl sm:text-3xl md:text-4xl font-bold mb-8 text-center"
          style={{ color: ink }}
        >
          Preguntas <span style={{ color: accentText }}>frecuentes</span>
        </h2>

        <div className="flex flex-col gap-2.5">
          {dentalFaq.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={item.q}
                className="rounded-xl border overflow-hidden"
                style={{
                  borderColor: isOpen ? 'rgba(6,182,212,0.35)' : border,
                  background: isLight ? '#ffffff' : 'rgba(4,16,31,0.75)',
                }}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : idx)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-panel-${idx}`}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  style={{ backgroundColor: isOpen ? 'rgba(6,182,212,0.07)' : 'transparent' }}
                >
                  <span
                    className="font-body text-sm font-semibold"
                    style={{ color: isOpen ? (isLight ? '#0e7490' : '#22d3ee') : ink }}
                  >
                    {item.q}
                  </span>
                  <i
                    className="ri-arrow-down-s-line text-lg flex-shrink-0 transition-transform duration-200"
                    style={{ color: '#06b6d4', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
                    aria-hidden="true"
                  />
                </button>
                {isOpen && (
                  <div
                    id={`faq-panel-${idx}`}
                    className="px-5 pb-4 pt-1"
                    style={{ borderTop: `1px solid ${border}` }}
                  >
                    <p className="font-body text-sm leading-relaxed" style={{ color: sub }}>
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
